import React, { Component } from "react";
import ExtjsReact from "app/common/utils/ExtReact";
import clone from "lodash/cloneDeep";

// class ExtjsCodeMirror1 extends ExtjsReact {
//   renderExtjsCmp() {
//     let me = this;
//     // setTimeout(
//     //   () => {
//     me.getExtjsCmp(this.renderTo);
//     // if (typeof me.props.value == "object") {
//     //   me.cmp.setValue(
//     //     me.props.value.query_string,
//     //     me.props.value.query_tree
//     //   );
//     // } else {
//     //   me.cmp.setValue(me.props.value || "");
//     // }
//     //   }
//     //   me.props.delayedRender ? 300 : 0
//     // );
//   }

//   getExtjsCmp = (renderTo) => {
//     var me = this;

//     return (me.cmp = Ext.create("TL.form.codemirror.codemirror", {
//       renderTo: renderTo,
//       mode: "javascript",
//       rows: 2,
//       growMax: 200,
//       cols: 50,
//       value: "",
//       oldVal: "",
//       isModified: false,
//       itemId: "formula-field",
//       emptyText: "columnName =",
//       listeners: {
//         keypress: function () {
//           me.props.onChange(this.getValue());
//         },
//         blur: function (obj, e, eOpts) {
//           me.props.onChange(this.getValue());
//         },
//         scope: this,
//       },
//     }));
//   };

//   getValue = () => this.cmp.getValue();
// }

const ExtjsCodeMirror = React.forwardRef(function ExtjsCodeMirror(
  { onChange, formula, columnName, columnTypeId, fullWidth = false, ...others },
  ref
) {
  const [renderTo] = React.useState(Util.getUniqueId());
  const extjsCriteriaPanelRef = React.useRef();

  React.useEffect(() => {
    let extjsCmp = Ext.create("TL.form.codemirror.codemirror", {
      renderTo: renderTo,
      mode: "javascript",
      rows: 2,
      growMax: 200,
      cols: 50,
      value: "",
      oldVal: "",
      isModified: false,
      itemId: "formula-field",
      emptyText: "columnName =",
      ...(fullWidth && { width: "100%" }),
      listeners: {
        keyup: function () {
          onChange(this.getValue());
        },
        scope: this,
      },
      ...others,
    });

    if (formula) {
      extjsCmp.setValue(formula);
    } else if (parseInt(columnTypeId) === 7) {
      extjsCmp.setValue(Util.toCamelCase(columnName) + " =");
    }

    if (ref) {
      ref.current = extjsCmp;
    }

    if (extjsCriteriaPanelRef) {
      extjsCriteriaPanelRef.current = extjsCmp;
    }

    return () => {
      extjsCmp.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderTo, onChange]);

  React.useEffect(() => {
    if (extjsCriteriaPanelRef.current) {
      if (extjsCriteriaPanelRef.current.getValue() !== formula) {
        extjsCriteriaPanelRef.current?.setValue(formula);
      }
    }
  }, [formula]);

  return <div id={renderTo} style={{ marginRight: 30 }}></div>;
});

export default ExtjsCodeMirror;
